/* Compra Fácil — aparición suave de las secciones del home.
   Si el navegador no soporta IntersectionObserver, todo se muestra de una vez. */
(function () {
  var seleccion = '.cfh-reveal';

  function mostrarTodo() {
    document.querySelectorAll(seleccion).forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  if (!('IntersectionObserver' in window)) {
    mostrarTodo();
    return;
  }

  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    mostrarTodo();
    return;
  }

  var observador = new IntersectionObserver(
    function (entradas) {
      entradas.forEach(function (entrada) {
        if (entrada.isIntersecting) {
          entrada.target.classList.add('is-visible');
          observador.unobserve(entrada.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );

  function observar() {
    document.querySelectorAll(seleccion + ':not(.is-visible)').forEach(function (el) {
      observador.observe(el);
    });
  }

  observar();

  // El editor del tema recarga secciones sueltas: hay que volver a observarlas.
  document.addEventListener('shopify:section:load', observar);
})();
